import React from 'react';
import { useLazyQuery } from '@apollo/client';
import { useRouter } from 'next/router';
import { Button, Card } from '@avila-tek/ui/src';
import { OrderPayment, PayableRequestInfo, User } from '../../../models';
import { useNotify, useUser } from '../../../hooks';
import {
  GET_USER,
  GET_USER_IN_ACCOUNT_SUMMARY,
} from '../../../graphql/queries';
import { OrderPaymentInfo, OrderPaymentSummary } from '../../orderPayment';
import ClientDetail from '../../order/OrderDetail/ClientDetail';
import { roles } from '../../../static';
import { Title } from '../../shared';
import { ComprobantModal } from '../../account';

interface AccountSummaryProps {
  data: PayableRequestInfo;
  setAmount?: React.Dispatch<React.SetStateAction<number>>;
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  setOrderProductId?: React.Dispatch<React.SetStateAction<string[]>>;
}

function AccountSummary({
  data,
  setAmount,
  setIsOpen,
  setOrderProductId,
}: AccountSummaryProps) {
  const [userData, setUserData] = React.useState<User | null>(null);
  const router = useRouter();
  const notify = useNotify();
  const [user] = useUser();

  const orderPayment: OrderPayment = React.useMemo(() => {
    // Found the orderPayment item by the orderPaymentId
    const orderPaymentItem = data.orderPayments.find(
      (orderPaymentData) => orderPaymentData._id === router.query.orderPaymentId
    );
    setOrderProductId([orderPaymentItem?.orderProduct._id]);
    return orderPaymentItem;
  }, [data]);

  const [getUser] = useLazyQuery<{
    user: User;
  }>(GET_USER_IN_ACCOUNT_SUMMARY, {
    fetchPolicy: 'network-only',
  });

  React.useEffect(() => {
    async function fetchData() {
      try {
        const { data: clientData } = await getUser({
          variables: {
            filter: {
              client: orderPayment.orderProduct.client,
            },
          },
        });
        setUserData(clientData?.user);
      } catch (error) {
        console.log(error);
        notify(error.message, 'error');
      }
    }
    fetchData();
  }, [orderPayment]);

  const onclick = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    setAmount(orderPayment.orderProduct.variant.agreedPrice);
    setIsOpen(true);
  };
  const [comprobantOpen, setCompribantOpen] = React.useState<boolean>(false);
  return (
    <section className="space-y-5">
      {user.userType !== roles.ally ? (
        <div
          className={`flex-col justify-center items-end ${
            orderPayment.paymentStatus === 'pending'
              ? 'flex lg:hidden'
              : 'hidden'
          }`}
        >
          <Button
            type="button"
            onClick={onclick}
            className="w-[35%] md:w-[33%]"
          >
            Pagar
          </Button>
        </div>
      ) : null}
      <div className="w-full flex flex-wrap">
        <div className="w-full lg:w-2/3 flex flex-col lg:pr-5 mb-5 ">
          <OrderPaymentSummary orderPayment={orderPayment} />
          <ClientDetail user={userData} />
        </div>
        <div
          className={`w-full lg:w-1/3 flex flex-col ${
            orderPayment.paymentStatus === 'pending' ? 'lg:space-y-5' : ''
          }`}
        >
          {user.userType !== roles.ally ? (
            <div
              className={`${
                orderPayment.paymentStatus === 'pending'
                  ? 'hidden lg:flex'
                  : 'hidden'
              }`}
            >
              <Button type="button" onClick={onclick}>
                Pagar
              </Button>
            </div>
          ) : null}

          <OrderPaymentInfo order={orderPayment} />
          {user.userType === roles.ally &&
          orderPayment.paymentStatus === 'paid' &&
          orderPayment.paymentRef.image ? (
            <Card className="p-4 sm:px-6 relative mt-5">
              <div className="space-y-1 flex flex-col">
                <Title title="Comprobante de pago" />
                <button
                  type="button"
                  onClick={() => setCompribantOpen(true)}
                  className="flex flex-col justify-center items-center"
                >
                  <img
                    src={orderPayment.paymentRef.image}
                    className="object-cover h-36 w-[100%] rounded-lg"
                    alt="Comprobante"
                  />
                </button>
              </div>
            </Card>
          ) : null}
        </div>
      </div>
      {user.userType === roles.ally &&
      orderPayment.paymentStatus === 'paid' &&
      orderPayment.paymentRef.image ? (
        <ComprobantModal
          isOpen={comprobantOpen}
          setOpen={setCompribantOpen}
          srcImge={orderPayment.paymentRef.image}
        />
      ) : null}
    </section>
  );
}

export default AccountSummary;
